import { keyframes, styled } from "@mui/material";
import { ReactElement, SVGProps } from "react";

export function SplashScreen(): ReactElement {
  return (
    <Container>
      <SplashLogo />
    </Container>
  );
}

export function SplashLogo(): ReactElement {
  return (
    <SplashLogoContainer>
      <StyledSvgLogo />
    </SplashLogoContainer>
  );
}

const SplashLogoContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}));

const Container = styled("div")(({ theme }) => ({
  position: "fixed",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  background: theme.palette.background.main,
  pointerEvents: "none",
}));

const SvgLogo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 107" {...props}>
      <path d="M34.6416 0C46.3357 32.4257 63.6033 41.0153 80.5432 41.0153C92.1279 41.0153 100.325 36.9353 100.325 36.9353L100.871 37.4722L23.3849 106.618V78.0578L64.8056 42.7331C14.6416 37.2575 0.871094 0 0.871094 0H34.6416Z" />
    </svg>
  );
};

const LogoPulseKeyframes = keyframes`
0% {
  transform: scale3d(1, 1, 1);
}
50% {
  transform: scale3d(1.2, 1.2, 1.2);
}
100% {
  transform: scale3d(1, 1, 1);
}
`;

const StyledSvgLogo = styled(SvgLogo)(({ theme }) => ({
  width: "75px",
  height: "75px",
  fill: theme.palette.brand.icon,
  animationTimingFunction: "ease-in-out",
  animationIterationCount: "infinite",
  animationFillMode: "both",
  animationDelay: "1s",
  animationDuration: "1.5s",
  animationName: LogoPulseKeyframes,
}));
